import { horizontalQuad } from '../geometry';
import type { Camera } from '../geometry';
import type { SceneRegion } from './types';

/**
 * Floor — a living room seen from its doorway: one long polished floor receding to a back wall, a tall
 * window on the left throwing light across it. Metres; eye height 1.45 m, 2.6 m in front of the room.
 */
export const floorCamera: Camera = { eye: [0, 1.45, -2.6], focal: 820, center: [600, 330] };

export const FLOOR = {
  half: 2.6,
  /** The floor starts a little in front of the frame so its near edge is never visible. */
  zNear: -0.2,
  zWall: 6.2,
  height: 2.9,
} as const;

const { half, zNear, zWall } = FLOOR;

export const floorRegions: readonly SceneRegion[] = [
  {
    id: 'floor',
    quad: horizontalQuad(floorCamera, -half, half, zNear, zWall, 0),
    size: [2 * half, zWall - zNear],
    tile: 0.85,
    bleed: 0.8,
  },
];
